import React from 'react';
import CommonModal from '../../../../../components/Modal';

export default function InvoiceErrorModal({ open, onClose, setIsUnique, errorList = [], onProceed, remainingCount }) {
    return (
        <CommonModal
            show={open}
            handleClose={() => { setIsUnique(true); onClose(); }}
            title="Invoice cannot be issued"
            className="px-0 py-0 font-normal"
            dialogueHeight={'500px'}
            dialogueWidth={'600px'}
        >
            <div
                className="mt-2 mb-4 px-8"
                
            >
                <p className="mb-2">
                    Invoice cannot be issued for the following {errorList.length} student{errorList.length > 1 ? 's' : ''}:
                </p>
                <div className="overflow-x-auto mb-4 scroll-bar" style={{height: '300px'}}>
                    <table class="w-full greyheader stickyhead" id='admin-table'>
                        <thead>
                            <tr>
                                <th className="w-[25%] text-left">
                                    Student Id
                                </th>
                                <th className="w-[25%]  text-left">
                                    Student Name
                                </th>
                                <th className="w-[50%]  text-left">
                                    Reason
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {errorList.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="text-left">{item.student_id}</td>
                                    <td className="text-left">{item.student_name}</td>
                                    <td className="text-left">
                                        {item.message}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="text-center text-base font-medium text-[#031624] mb-4">
                    {`Would you like to issue invoice for the remaining ${remainingCount} student` +
                    `${remainingCount > 1 ? 's' : ''}?`}
                </div>
                <div className="flex justify-center gap-1 mt-2">
                    <button
                        className="cancl-btn1"
                        onClick={() => {
                            setIsUnique(true)
                            onClose()
                        }}
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        className="actn-btn1"
                        onClick={onProceed}
                        type="button"
                    >
                        Proceed
                    </button>
                </div>
            </div>
        </CommonModal>
    );
} 